import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';

import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  private logoutPollInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.authService.clearLogoutBroadcast();
    this.logoutPollInterval = setInterval(() => {
      if (this.authService.hasLogoutBroadcast()) {
        this.authService.clearLogoutBroadcast();
        this.authService.clearAuthData();
        this.router.navigate(['/login']);
      }
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.logoutPollInterval !== null) {
      clearInterval(this.logoutPollInterval);
    }
  }
}
